import React from 'react';
import styles from './scss/slackthank.module.scss'
import firstImage from '../styles/images/slack.svg';
import secondImage from '../styles/images/connector.svg';
import worktualImage from '../styles/images/worktual.png';
function SlackSuccess() {

    return (
        <div className={styles.slackthankspage}>
        <div>
          <div className={styles.panel}>
            <div className={styles.wrapper}>
              <img src={firstImage} alt="" className={styles.logo} />
            </div>
            <img src={secondImage} alt="" className={styles.logo} />
            <div className={styles.wrapper}>
              <img src={worktualImage} alt="" className={styles.logo} />
            </div>
          </div>
          <div className={styles.content}>
            <p>
              You have successfully installed the Worktual for Slack integration.
              Get started by using the '/worktual' Slack slash command.<br></br>
            </p>
            {/* <p>
              If your are not have App for Slack. Please click this{" "}
              <a
                href="https://slack.com/intl/en-in/downloads/windows"
                target="_blank"
              >
                link
              </a>{" "}
              to download
            </p> */}
            <p>This browser tab can now be closed and you can continue on Slack.</p>
          </div>
        </div>
      </div>
    )
}
export {SlackSuccess};